import React from 'react';
import { Accordion, Stack } from '@chakra-ui/react';
import { useTranslation } from 'localization';
import Approved from 'pages/Requests/components/Approved';
import DepositSettled from 'pages/Requests/components/DepositSettled';
import RateForm from 'pages/Requests/components/RateForm';
import { Proposal } from 'types';

import { LDTransactionCard, LDTransactionMessage } from 'components';

type ProposalCardProps = {
  proposal: Proposal;
  refetch: () => void;
  refetchTransaction: () => void;
};

const ProposalCard: React.FC<ProposalCardProps> = ({
  proposal,
  refetch,
  refetchTransaction,
}: ProposalCardProps) => {
  const { t } = useTranslation('component.requests.proposals');

  const STATES: Record<Proposal['status'], React.ReactElement | string> = {
    INIT: proposal ? (
      <RateForm proposalId={proposal.id} refetch={refetch} />
    ) : (
      ''
    ),
    PENDING: (
      <Stack>
        <LDTransactionMessage
          title={t('waitForUser')}
          status="info"
          textProps={{ color: 'info' }}
        />
      </Stack>
    ),
    CANCELED: (
      <Stack>
        <LDTransactionMessage
          title={t('canceled')}
          status="error"
          textProps={{ color: 'error' }}
        />
      </Stack>
    ),
    APPROVED: proposal ? (
      <Approved
        proposalId={proposal.id}
        paymentMethod={proposal.payment_method}
        refetch={refetch}
      />
    ) : (
      ''
    ),
    REJECTED: (
      <Stack>
        <LDTransactionMessage
          title={t('rejected')}
          status="error"
          textProps={{ color: 'error' }}
        />{' '}
      </Stack>
    ),
    SETTLED: proposal ? (
      <DepositSettled
        defaultBankTransfer={
          proposal?.source_wallet?.user?.ld_contract?.bank_account
        }
        paymentMethod={proposal.payment_method}
        proposalId={proposal.id}
        refetch={() => {
          refetch();
          refetchTransaction();
        }}
      />
    ) : (
      ''
    ),
    COMPLETED: '',
    FAILED: '',
  };

  return (
    <Accordion.ItemContent pb={4}>
      <Accordion.ItemBody>
        <LDTransactionCard
          amount={proposal.amount}
          identifier_number={
            proposal?.destination_wallet?.user?.identifier_number || 0
          }
          pay_with={proposal.pay_with}
          symbol={proposal?.source_wallet?.currency?.symbol}
          rate={proposal.rate}
          note={proposal.note}
          payment_method={proposal.payment_method}
          receivingValue={proposal.amount * proposal.rate}
          panel="LD"
          method="DEPOSIT"
        />
        <Stack mt="2">{STATES[proposal.status]}</Stack>
      </Accordion.ItemBody>
    </Accordion.ItemContent>
  );
};
export default ProposalCard;
